/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Patient Profile View.
 */

// Redux Actions
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './patientProfile';

export const mapStateToPropsPatientProfile = mapStateToProps;
export const mapDispatchToPropsPatientProfile = mapDispatchToProps;

export default connect(
  mapStateToPropsPatientProfile,
  mapDispatchToPropsPatientProfile
)(View);
